import React from 'react';
import _ from 'lodash';
import Transition from 'react-overlays/lib/Transition';
import styles from './Collapse.styl';

/**
 * Collapse Component
 * @class Collapse
 */
export default class Collapse extends React.Component {
  static propTypes = {
    ariaRole: React.PropTypes.string,
    baseHeight: React.PropTypes.number,
    children: React.PropTypes.node,
    in: React.PropTypes.bool,
    onEnter: React.PropTypes.func,
    onEntered: React.PropTypes.func,
    onEntering: React.PropTypes.func,
    onExit: React.PropTypes.func,
    onExited: React.PropTypes.func,
    onExiting: React.PropTypes.func,
    timeout: React.PropTypes.number,
    transitionAppear: React.PropTypes.bool,
    unmountOnExit: React.PropTypes.bool,
  };

  static defaultProps = {
    baseHeight: 0,
    in: false,
    timeout: 300,
    transitionAppear: false,
    unmountOnExit: false,
  };

  /**
   * Collapse component constructor
   * @param  {object}     props passed in properties
   * @return {undefined}  returns nothing
   */
  constructor(props) {
    super(props);

    this.handleEnter = this.handleEnter.bind(this);
    this.handleEntered = this.handleEntered.bind(this);
    this.handleEntering = this.handleEntering.bind(this);
    this.handleExit = this.handleExit.bind(this);
    this.handleExiting = this.handleExiting.bind(this);
  }

  /**
   * Callback for when entering begins
   * @param  {element}    elem the animated element
   * @return {undefined}  returns nothing
   */
  handleEnter(elem) {
    elem.style.height = '0';

    if (_.isFunction(this.props.onEnter)) {
      this.props.onEnter();
    }
  }

  /**
   * Callback for when entering ends
   * @param  {element}    elem The animated element
   * @return {undefined}  returns nothing
   */
  handleEntered(elem) {
    elem.style.height = null;

    if (_.isFunction(this.props.onEntered)) {
      this.props.onEntered();
    }
  }

  /**
   * Callback for when entering
   * @param  {element}    elem the animated element
   * @return {undefined}  returns nothing
   */
  handleEntering(elem) {
    elem.style.height = `${elem.scrollHeight}px`;

    if (_.isFunction(this.props.onEntering)) {
      this.props.onEntering();
    }
  }

  /**
   * Callback for when exiting begins
   * @param  {element}    elem the animated element
   * @return {undefined}  returns nothing
   */
  handleExit(elem) {
    const height =
      elem.offsetHeight + elem.style.marginTop + elem.style.marginBottom;

    elem.style.height = `${height}px`;

    if (_.isFunction(this.props.onExit)) {
      this.props.onExit();
    }
  }

  /**
   * Callback for when exiting
   * @param  {element}    elem        the animated element
   * @param  {number}     baseHeight  minimum starting height
   * @return {undefined}  Returns nothing
   */
  handleExiting(elem, baseHeight) {
    // eslint-disable-next-line no-unused-expressions
    elem.offsetHeight;
    elem.style.height = `${baseHeight}px`;

    if (_.isFunction(this.props.onExiting)) {
      this.props.onExiting();
    }
  }

  /**
   * React component render
   * @return {JSX} Collapse rendered
   */
  render() {
    const {baseHeight, ...rest} = this.props;
    const exitingClasses = baseHeight
      ? `${styles.Collapse} ${styles.teaser}`
      : styles.Collapse;

    return (
      <Transition
        {...rest}
        enteredClassName={styles.in}
        enteringClassName={styles.collapsing}
        exitedClassName={exitingClasses}
        exitingClassName={styles.collapsing}
        onEnter={this.handleEnter}
        onEntered={this.handleEntered}
        onEntering={this.handleEntering}
        onExit={this.handleExit}
        onExiting={_.partial(this.handleExiting, _, this.props.baseHeight)}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/shared/library/Collapse/Collapse.js